import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      cursor: text;\n\n      & ::selection {\n        background: ", ";\n      }\n      & ::-moz-selection {\n        background: ", ";\n      }\n    "])), t.dateInputComponentSelectedBgColor, t.dateInputComponentSelectedBgColor);
  },
  selected: function selected(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n      background-color: ", ";\n    "])), t.dateInputComponentSelectedBgColor, t.dateInputComponentSelectedBgColor);
  },
  mask: function mask(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.dateInputMaskColor);
  },
  delimiterFilled: function delimiterFilled() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: inherit;\n    "])));
  }
});